import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { LayoutsModule } from "app/layouts";
import { NewTicketComponent } from "./new-ticket";
import { ClosedTicketsComponent } from "./closed-tickets/closed-tickets.component";
import { TicketDetailsComponent } from "./details";

import { CommonLayoutComponent } from "../../layouts/common-layout";



@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: "",
        component: CommonLayoutComponent,
        children: [
          { path: "app/tickets/new", component: NewTicketComponent, pathMatch: "full" },
          { path: "app/tickets/closed", component: ClosedTicketsComponent, pathMatch: "full" },
          { path: "app/tickets/details/:id", component: TicketDetailsComponent, pathMatch: "full" },
        ],
      },
    ]),
    LayoutsModule,
  ],
  exports: [RouterModule],
})
export class TicketsRoutingModule { }
